/* global _ */
import FormMixin from '../../../../../../../mixins/form'
import ProductMixin from '../../../../../../../mixins/store/products'
import ProductFilterMixin from '../../../../../../../mixins/store/products-filter'

export default {
  mixins: [FormMixin, ProductMixin, ProductFilterMixin],
  data() {
    return {
      fields: {
        product: null,
        quantity: 1,
      },
      cartItemTemplate: {},
      reactiveDataDef: {},
      reactiveData: {},
    }
  },
  computed: {
    contentBefore() {
      const $s = _.values(this.$$s('components.header', []))
      const $t = _.values(this.$$t('components.header', []))
      return _.merge([], $t, $s)
    },
    contentAfter() {
      const $s = _.values(this.$$s('components.footer', []))
      const $t = _.values(this.$$t('components.footer', []))
      return _.merge([], $t, $s)
    },
    formOptions() {
      const $s = this.$$s('form', {})
      const $t = this.$$t('form', {})
      return _.merge({}, $t, $s)
    },
    form() {
      return this.formOptions
    },
    formGroups() {
      return this.form.fieldGroups || {}
    },
    hasFormGroups() {
      return !_.isEmpty(this.formGroups)
    },
    formGroupsOrder() {
      return this.form.fieldGroupsOrder || _.keys(this.formGroups)
    },
    formGroupsOrdered() {
      return _.reduce(this.formGroupsOrder, (groups, groupName) => {
        const group = this.formGroups[groupName]
        if (group) {
          groups.push(group)
        }
        return groups
      }, [])
    },
    formFields() {
      const fields = this.form.fields
      return _.mapValues(fields, (field, key) => {
        field.name = field.name || key
        return field
      })
    },
    formFieldOrder() {
      return this.form.$fieldsOrder || this.form.fieldsOrder || this.form.order ||
        _.reduce(this.formFields, (names, field, key) => {
          names.push(field.name || key)
          return names
        }, [])
    },
    formFieldOrdered() {
      return _.reduce(this.formFieldOrder, (fields, fieldName) => {
        const field = this.formFields[fieldName]
        if (field) {
          fields.push(field)
        }
        return fields
      }, [])
    },
    products() {
      const filters = this.$$s('products.filters', {})
      return _.cloneDeep(this.applyFilterOnProducts(filters, null, true))
    },
  },
  created() {
    this.setupAutoForm()
    this.setupReactives()
  },
  methods: {
    buildCartItem() {
      const $s = this.$$s('cart.item', {})
      const $t = this.$$t('cart.item', {})
      const template = _.merge({}, this.cartItemTemplate, $t, $s)
      const item = this.parseReactiveDataRecursive(template)
      const uid = _.uniqueId((new Date()).valueOf() + '_')
      const id = _.filter([item.payload.product_id, item.payload.options.location_id, uid]).join('_')
      item.id = id
      item.total = (item.attributes.product.rate || item.attributes.product.price) * item.payload.count
      return item
    },
    async safeAddToCartNoRedirect(e) {
      await this.$validate()
      if (!this.isAnyInvalid) {
        await this.addToCart(false)
      }
    },
    getReactiveData() {
      return {
        this: this,
        fields: this.fields,
        ...this.fields,
        data: this.reactiveData,
        ...this.getReactiveExtraData()
      }
    },
    getReactiveExtraData() {
      return {}
    },
    setupReactives() {
      const $s = this.$$s('reactive', {})
      const $t = this.$$t('reactive', {})
      const helpers = {
        valueGetter: v => _.get(this.reactiveData, v),
        propGetter: v => _.get(this.reactiveDataDef, v),
        valueSetter: (k, v) => this.$set(this.reactiveData, k, v),
        propSetter: (name, v) => {
          _.forOwn(v, (value, key) => {
            this.$set(this.reactiveDataDef[name], key, value)
          })
        }
      }
      this.reactiveDataDef = _.mapValues(_.merge({}, $t, $s), (item, key) => {
        item.helpers = helpers
        item.key = key
        return item
      })
      _.forOwn(this.reactiveDataDef, (def, key) => {
        let value = def.default
        this.$set(this.reactiveData, key, value)
      })
      this.setupReactiveItems(this.reactiveDataDef, {
        data: this.getReactiveData,
        namespace: 'reactiveData',
      })

      const valueGetter = (v) => {
        return this.fields[v]
      }
      const propGetter = (v) => {
        return this.formFields[v]
      }
      const valueSetter = (k, v) => {
        this.$set(this.fields, k, v)
      }
      const propSetter = (name, v) => {
        _.forOwn(v, (value, key) => {
          this.$set(this.formFields[name], key, value)
        })
      }
      const namespace = 'fields'
      this.setupReactiveItems(this.formFields, {
        data: this.getReactiveData,
        namespace,
        valueGetter,
        propGetter,
        valueSetter,
        propSetter
      })
    },
    hydrateFields(fields, fieldsKey = 'fields') {
      let hydrateUser = this.form.hydrateUser || {}
      if (hydrateUser === true) {
        let values = this.userDataMeta || {}
        hydrateUser = _.keys(values)
      }
      if (_.isArray(hydrateUser)) {
        hydrateUser = _.reduce(hydrateUser, (all, key) => {
          all[key] = 'userDataMeta.' + key
          return all
        }, {})
      }
      const hydrates = {...hydrateUser, ...(this.form.hydrate || {})}
      const form = this[fieldsKey] || this
      _.forOwn(hydrates, (source, key) => {
        if (_.has(form, key)) {
          const value = _.get(this, source)
          if (!_.isNil(value)) {
            form[key] = value
          }
        }
      })
    },
    parsePartData(def, path, data, skipNil, defaultValue) {
      const value = this.parseReactiveDataRecursive(def, data, skipNil, {path})
      return _.isNil(value) ? defaultValue : value
    },
    getFieldContainerExtraClasses(fieldName, fieldsPath, field) {
      return [field.containerClasses]
    },
    getFormFieldAttrs(field) {
      const key = field.name
      field = this.parseReactiveDataRecursive(field, null, true)
      const $$v = this.$v
      const validations = this.validations[key] || {}
      return {
        context: this,
        key,
        validations,
        $$v,
        field,
        vRoot: $$v.fields,
        v: $$v.fields[key],
        classes: this.getFieldContainerClasses(key),
        customErrors: this.fieldCustomErrors[key],
      }
    },
  }
}
